import { render, staticRenderFns } from "./ChristmasDining2025_defaultSection.vue?vue&type=template&id=d602da82&scoped=true"
import script from "./ChristmasDining2025_defaultSection.vue?vue&type=script&lang=ts"
export * from "./ChristmasDining2025_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./ChristmasDining2025_defaultSection.vue?vue&type=style&index=0&id=d602da82&prod&lang=css"
import style1 from "./ChristmasDining2025_defaultSection.vue?vue&type=style&index=1&id=d602da82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d602da82",
  null
  
)

export default component.exports